export default function TSeriesInventory() {
  return {
    restrict: 'E',
    scope: {},
    template: require('./inventory.html'),

    controller: function ($scope, $interval, TSeriesService, gettextCatalog) {
      'ngInject';

      $scope.errorFlag = false;
      $scope.errorText = '';
      $scope.loading = false;
      $scope.isFirstLoad = true;
      $scope.inventoryMessage = gettextCatalog.getString('No inventory reported today.');
      var timer = null;

      //Refreash the Top 5 Inventory Chart on a 1 minute interval
      var c = 0;
      timer = $interval(function () {
        c++;
        if (c === 60 && $scope.isFirstLoad == false) {
          c = 0;
          getInventorySummary();
          getInventoryDetails();
        }
      }, 1000);

      var populateInventoryChart = function () {
        var chart = AmCharts.makeChart('inventoryChart', {
          type: 'pie',
          theme: 'light',
          dataProvider: $scope.inventorySummaryList,
          valueField: 'count',
          labelText: '[[make_model]]',
          titleField: 'make_model',
          outlineAlpha: 0.4,
          depth3D: 0,
          radius: '35%',
          startDuration: 0,
          balloonText: "[[make_model]]<br><span style='font-size:14px'><b>[[count]]</b></span>",
          angle: 0,
          export: {
            enabled: false
          },
          listeners: [{
            event: 'init',
            method: function (event) {
              // apply slice colors to their labels
              var chart = event.chart;
              if (chart.labelColorField === undefined) chart.labelColorField = 'labelColor';
              for (var i = 0; i < chart.chartData.length; i++) {
                chart.dataProvider[i][chart.labelColorField] = chart.chartData[i].color;
              }
              chart.validateData();
            }
          }]
        });
      };
      //Add Legend to the Inventory Top 5 Chart
      //var legend = new AmCharts.AmLegend();
      //chart.addLegend(legend, "inventorylegenddiv");

      //Request Inventory Summary for Top 5 T-Series
      var getInventorySummary = function () {
        $scope.errorFlag = false;
        $scope.errorText = '';
        $scope.isFirstLoad = false;
        $scope.loading = true;
        TSeriesService.getInventorySummary()
          .then(function (response) {
            $scope.inventorySummaryList = [];
            for (var i = 0; i < response.data.length; i++) {
              $scope.inventorySummaryList.push({
                make_model: response.data[i].make + ' ' + response.data[i].model,
                count: response.data[i].count
              });
            }

            $scope.loading = false;
            populateInventoryChart();
          })
          .catch(function (error) {
            var errorMsg = gettextCatalog.getString('Unable to retrive T-Series Inventory Summary.');
            $scope.errorFlag = true;
            $scope.errorText = errorMsg;
          })
          .finally(function () {
            $scope.loading = false;
          });
      }; //getTSeriesInventory

      getInventorySummary();

      ////Request Inventory Details for CSV Export
      var getInventoryDetails = function () {
        $scope.errorFlag = false;
        $scope.errorText = '';
        $scope.loading = true;
        TSeriesService.getInventoryDetail()
          .then(function (response) {
            $scope.inventoryDetailList = [];
            for (var i = 0; i < response.data.length; i++) {
              $scope.inventoryDetailList.push(response.data[i]);
            }

            $scope.loading = false;
          })
          .catch(function (error) {
            var errorMsg = gettextCatalog.getString('Unable to retrieve T-Series Inventory Details.');
            $scope.errorFlag = true;
            $scope.errorText = errorMsg;
          })
          .finally(function () {
            $scope.loading = false;
          });
      }; //getTSeriesInventory

      getInventoryDetails();

      //Give the csv file it's respective name and append the datetime
      $scope.getCsvFileName = function () {
        if (!$scope.inventoryDetailList) return '';

        var fileName = gettextCatalog.getString('T-Series Inventory');
        var d = new Date();
        var date =
          d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + '-' + d.getHours() + '-' + d.getMinutes();
        fileName += '.' + date;
        return fileName + '.csv';
      };

      $scope.getCsvData = function () {
        var CsvData = [];

        var headers = {
          Make: 'Make',
          Model: 'Model',
          Count: 'Count'
        };

        CsvData.push(headers);

        for (var i = 0; i < $scope.inventoryDetailList.length; i++) {
          var make = $scope.inventoryDetailList[i].make;
          var model = $scope.inventoryDetailList[i].model;
          var count = $scope.inventoryDetailList[i].count;

          var csvObject = {
            Make: make,
            Model: model,
            Count: count
          };

          CsvData.push(csvObject);
        }
        return CsvData;
      };
      // cancel the timer when navigate away.
      $scope.$on('$destroy', function () {
        if (timer) {
          $interval.cancel(timer);
        }
      });
    }
  };
}